import React from 'react';
import { useMediaQuery } from 'react-responsive';

interface IBreakpoints {
  extraSmall: number;
  small: number;
  medium: number;
  large: number;
  extraLarge: number;
}

export const breakpoints: IBreakpoints = {
  extraSmall: 576,
  small: 768,
  medium: 992,
  large: 1200,
  extraLarge: 1400,
};

export const Desktop = ({ children }: { children: React.ReactElement }): React.ReactElement | null => {
  const isDesktop = useMediaQuery({ minWidth: breakpoints.medium });
  return isDesktop ? children : null;
};
export const Tablet = ({ children }: { children: React.ReactElement }): React.ReactElement | null => {
  const isTablet = useMediaQuery({
    minWidth: breakpoints.small,
    maxWidth: breakpoints.medium,
  });
  return isTablet ? children : null;
};
export const Mobile = ({ children }: { children: React.ReactElement }): React.ReactElement | null => {
  const isMobile = useMediaQuery({ maxWidth: breakpoints.small });
  return isMobile ? children : null;
};
export const TabletAndDesktop = ({ children }: { children: React.ReactElement }): React.ReactElement | null => {
  const isNotDesktop = useMediaQuery({
    minWidth: Number(breakpoints.small) + 1,
  });
  return isNotDesktop ? children : null;
};
